import React, { Component } from 'react';
import axios from 'axios'
import { Form, Segment, Header, Button, } from 'semantic-ui-react'
import { getProjectList } from './ApiUtils'
import { getProjectDropDown } from './LargeProjectUtils'
import Select from 'react-select';
import { firebaseAuth, pythonApiIp, getOrderKey, logComponentLoad, logDashboardAction } from '../../../../config/constants'
import { checkAdminEmail, getOrderFromAlogolia } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import { algoliaPartialUpdateOrder } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as moment from 'moment';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class AddOrderToProject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            projectChoices: [],
            order: '',
            projectId: '',
            algoliaUser:''
        }
    }


    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");
        console.log("filtx: filter:" + this.props.filter)

        // this.getProjectList();


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                    //  this.getApiDetails();
                    //this.getProjectList();


                    if (this.props.match.params.fbOrderKey) {
                        console.log("got fbOrderKey:" + this.props.match.params.fbOrderKey);

                        getOrderFromAlogolia(this.props.match.params.fbOrderKey, this.loadOrder);

                        getProjectList(this.loadProjectList, "not_closed");
                    } else {
                        alert("no fbOrderKey was sent")
                    }
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "AddOrderToProject");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    loadOrder = (sentOrder) => {
        console.log("golx13 ++++++++:loadOrder");
        this.setState({
            order: sentOrder
        })
    }

    loadProjectList = (projects) => {
       // console.log("gpx12 ++++++++:loadProjectList");

        if (projects && projects.length > 0) {
            this.setState({
                loading: false,
                projectChoices: getProjectDropDown(projects)
            })
        } else {
            alert("unable to load projects")
        }
    }

    addOrderNumber = () => {
        console.log("++++++++:addOrderNumber");

        if (this.state.projectId == '') {
            alert("projectId not set")
        } else if (!this.state.order.order_num) {
            alert("order_num not set")
        } else {

            this.setState({ loading: true })

            axios.post(pythonApiIp + 'addOrderToProject', {
                apiKey: "PrintB@da7",
                projectId: this.state.projectId,
                order_num: this.state.order.order_num
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding customer");
                        console.log("pltx2 :" + JSON.stringify(response.data, null, 3))

                        if (response.data.order) {


                            if (this.state.order.archived || this.state.order.algoliaArchived) {
                                console.log("this.order.archived || this.order.algoliaArchived is true");
                                let now = moment().format('MMMM Do YYYY, h:mm:ss a');
                                let orderUpdates = {
                                    largeproject: response.data.order.largeproject.name,
                                    largeprojectid: response.data.order.largeproject.idlargeprojects,
                                    largeprojectcustomer: response.data.order.largeproject.largeprojectcustomer.customername,
                                    largeprojectcustomerid: response.data.order.largeproject.largeprojectcustomer.idlargeprojectcustomer,
                                    lastUpdated: now,
                                    lastUpdatedBy: this.state.user.email,
                                    objectID: getOrderKey(this.state.order)
                                }
                                //UDPATE IN ALGOLIA ONLY
                                algoliaPartialUpdateOrder(orderUpdates);
                            } else {
                                console.log("order is NOT ARCHIVED")

                                let now = moment().format('MMMM Do YYYY, h:mm:ss a');
                                let orderUpdates = {
                                    largeproject: response.data.order.largeproject.name,
                                    largeprojectid: response.data.order.largeproject.idlargeprojects,
                                    largeprojectcustomer: response.data.order.largeproject.largeprojectcustomer.customername,
                                    largeprojectcustomerid: response.data.order.largeproject.largeprojectcustomer.idlargeprojectcustomer,
                                    lastUpdated: now,
                                    lastUpdatedBy: this.state.user.email
                                }

                                FbUtils.updateOrder(getOrderKey(this.state.order), orderUpdates);
                            }

                            logDashboardAction(this.state.user.email + " added order  " + getOrderKey(this.state.order) + " for " + response.data.order.largeproject.name, this.state.user.email, null, "AddOrderToProject");

                            alert(response.data.message);
                            history.push("/dashboard/searchNow");
                        } else if (!response.data.order) {
                            alert("NO order object returned")
                        }



                    } else {
                        console.log("FAILED");
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        console.log("docx195 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    render() {

        const orderNumber = this.state.order != '' && this.state.order.order_num
            ? <Header as='h2' color='red'>
                {this.state.order.order_num}
                <Header.Subheader>
                    ORDER NUMBER
</Header.Subheader>
            </Header>
            : ''

        const itemType = this.state.order != '' && this.state.order.itemType
            ? <Header as='h3' color='blue'>
                {this.state.order.itemType}
                <Header.Subheader>
                    ITEM TYPE
</Header.Subheader>
            </Header>
            : ''

        const phone = this.state.order != '' && this.state.order.phone
            ? <Header as='h3' color='teal'>
                {this.state.order.phone}
                <Header.Subheader>
                    phone
</Header.Subheader>
            </Header>
            : ''

        const sendButton = this.state.projectId != ''
            ? <Button onClick={this.addOrderNumber}> SEND </Button>
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("AddOrderToProject")
            ? <div>
                 <h1> </h1>
            {orderNumber}
            {itemType}
            {phone}

            <Form size='large' onSubmit={this.sendProject}>
                <Segment stacked>
                    <Select
                        name="form-field-name"
                        value={this.state.projectId}
                        options={this.state.projectChoices}
                        onChange={this.handleDropDownChanges}
                        searchable={false}
                        clearable={false}
                    />
                </Segment>
                {sendButton}
            </Form>
            </div>
            : <h4>loading error a75</h4>

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>

            {wholeUI}

           
        </div>);
    }
}

export default AddOrderToProject;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/AddOrderToProject.js